<template>
    <modal @close="closeModal" dusk="upgrade-server">
        <div class="u-padding-narrow u-full-height">
            <div class="u-margin-bottom"></div>
            <div class="layout layout--center | u-full-height">
                <div class="layout__item u-4/5-desk">
                    <div class="product | u-wizard-padding-bottom">
                        <div class="product__title">
                            <h2 class="beta | u-margin-bottom-narrow">{{ trans('order.vps-choose') }}</h2>
                        </div>
                        <vps-upgrade-plans :domain="domain" v-on:childToParent="onChildClick" />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray btn-ghost--vps | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record btn-ghost--vps" type="submit" @click="upgradeServer">
                {{ trans('action.save') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import VpsUpgradePlans from "./VpsUpgradePlans";
import VpsApi from '../services/api/vps.js';
import {Way2Form} from "relapp-way2forms/src/way2forms";

export default {
    components: {
        Modal,
        VpsUpgradePlans
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        server: Object
    },
    data() {
        return {
            vps: this.server,
            vpsName: ''
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },
        upgradeServer() {
            VpsApi.upgradeServer(this.domain, this.vps.data.id, new Way2Form({
                vpsName: this.vpsName
            }),).then(() => {
                EventBus.$emit('notification', {
                    type: 'success',
                    message: trans('action.saved')
                });
            })
                .catch(error => {
                    this.showError(error);
                });

            this.$emit('close');
        },
        onChildClick (value) {
            this.vpsName = value;
        }
    }
};
</script>
